import { Coordinates } from '../response-models/coordinates.model';
import { recordOrEmpty } from './is-record';

/**
 * Reads the hub's `{ latitude, longitude }` geocode `data`. `null` unless both are finite numbers (0 is a
 * valid coordinate).
 */
export function toCoordinates(data: unknown): Coordinates | null {
  const source = recordOrEmpty(data);
  const lat = source['latitude'];
  const lng = source['longitude'];
  return isFiniteNumber(lat) && isFiniteNumber(lng) ? { lat, lng } : null;
}

/** The hub's PUT `.../coordinates` body. */
export function toCoordinatesRequest(coords: Coordinates): { latitude: number; longitude: number } {
  return { latitude: coords.lat, longitude: coords.lng };
}

function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}
